
















































import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
// require styles
import "swiper/dist/css/swiper.css";
import "video.js/dist/video-js.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import videojs from "video.js";
let vm: any = null;
@Component({
    components: {
        swiper,
        swiperSlide,
    },
})
export default class Banner extends Vue {
    public $route!: Route;
    public $refs!: {
        swiper: any;
        videoPlayer: any;
    };
    private swiperOption: any = {
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        on: {
            click: function () {
                let url: string =
                    vm.dataInfo.banner_list[
                        // tslint:disable-next-line
                        (this as any).realIndex
                    ].url_p;

                if (url === "") {
                    return;
                }
                window.open(url);
            },
        },
    };

    private get swiper() {
        return this.$refs.swiper ? this.$refs.swiper.swiper : {};
    }

    private player: any = null;
    private isPlaying: boolean = false;
    private get dataInfo() {
        const banner_list = this.$store.state.common.banner.banner_list;
        if (banner_list && banner_list.length === 1) {
            this.swiperOption.autoplay = false;
        }
        return this.$store.state.common.banner;
    }
    mounted() {
        vm = this;
    }
    playVideo() {
        console.log("播放了");
        this.$refs.videoPlayer.play();
    }
    pauseVideo() {
        console.log("暂停了");
        this.$refs.videoPlayer.pause();
    }
    toggle(e:any) {
        if (this.$refs.videoPlayer.paused) {
            this.playVideo();
        } else {
            this.pauseVideo();
        }
    }
}
